import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormWrapper from "../../../../../library/form/components/FormWrapper";
import ProdIOListQtyCell, { ProdIOListUnitCell } from './ProdIOListQtyCell';

const ProdIOOExoSumViewRow = (props) => {
    const { formObject, rowKey } = props;

        return (
            <ul className="uiDPEditLine uiTableRowLevel1">
                <li className="uiColumnLeft uiColumn130">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
                </li>
                <li className="uiColumnLeft uiColumn350">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ 
                            paramName: "actualItem", 
                            actionId: "show", actionName: "itemComp",
                            containerKey: "custom",
                            actionParam:{showModeID: "qv"} 
                        }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <ProdIOListUnitCell formObject={formObject} rowKey={rowKey} param1="unit1" param2="unit2" />
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig" 
                    action={{ paramName: "variation1Name" }} >
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation1" }} />
                </FormWrapper>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig" 
                    action={{ paramName: "variation2Name" }} >
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation2" }} />
                </FormWrapper>
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyRequired1" param2="qtyRequired2" className="uiColumnGroupSplit" format="a" />
                <FormWrapper formObject={formObject} headerKey="viewConfig" action={{ paramName: "enableQC" }} >
                    <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyQCed1" param2="qtyQCed2" format="a" />
                    <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyPassed1" param2="qtyPassed2" format="a" />
                    <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyFailed1" param2="qtyFailed2" className="uiColumnGroupSplit" format="a" />
                </FormWrapper>
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyAvailable1" param2="qtyAvailable2" format="a" />
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtySendBack1" param2="qtySendBack2" format="a" />
                <li className="uiColumnCenter uiColumn90 uiSpacer5">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "status" }} />
                </li>
            </ul>
        )
}

export default ProdIOOExoSumViewRow
